import { propertiesTypes } from '@/reports/types';
import { commaFormatCurrency } from '@/utils/commaFormat/commaFormatCurrency';

export function formatAssessmentOfProperty(
  rawProperty: propertiesTypes.Property
) {
  return [
    [
      'Land Value',
      commaFormatCurrency(rawProperty?.values?.assessments?.[0]?.land) || '-',
    ],
    [
      'Improvements',
      commaFormatCurrency(
        rawProperty?.values?.assessments?.[0]?.improvements
      ) || '-',
    ],
    [
      'Total Value',
      commaFormatCurrency(rawProperty?.values?.assessments?.[0]?.total) || '-',
    ],
  ];
}
